"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _utils = require("../utils");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CheckboxField = props => {
  var {
    language = _constants.CONTENTFUL_LOCALE.en,
    label,
    options = [],
    minSelected,
    maxSelected,
    isRequired = false,
    onChange = (value, isValid) => {},
    // eslint-disable-line no-unused-vars,
    clickedSubmit = false,
    fieldName,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    errorMessage = '',
    twoColumnsOnDesktop = false,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    value = [],
    isReadOnly = false
  } = props;
  var getValidationErrorMessage = () => {
    return "".concat(_staticContent.CHECKBOX_FIELD.ERROR_MSG[language], " ").concat(_staticContent.CHECKBOX_FIELD.MIN_MAX_MESSAGE.MIN[language], " ").concat(minSelected || (isRequired ? 1 : 0), " ").concat(_staticContent.CHECKBOX_FIELD.MIN_MAX_MESSAGE.MAX[language], " ").concat(maxSelected || options.length);
  };
  var errMsg = errorMessage || getValidationErrorMessage();
  var hasOptions = Array.isArray(options) && options.length > 0;
  var valuesFoundInOptions = value.filter(valueInOption => options.some(object => object.value === valueInOption));
  var [itemsChecked, setItemsChecked] = (0, _react.useState)(new Set(valuesFoundInOptions));
  var [hasInteracted, setHasInteracted] = (0, _react.useState)(false);
  var [checkBoxFeedback, setCheckBoxFeedback] = (0, _react.useState)(undefined);
  var [checkBoxError, setCheckBoxError] = (0, _react.useState)(undefined);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  var validate = (0, _react.useCallback)(() => {
    // Assume the field is valid, until proven otherwise
    var isValid = true;

    // When required, we need to ensure there is at least one item checked
    isValid = isValid && (isRequired ? itemsChecked.size > 0 : true);

    // Ensure a minimum selection matches props
    var hasMinSelected = minSelected !== undefined && typeof minSelected === 'number';
    isValid = isValid && (hasMinSelected ? itemsChecked.size >= minSelected : true);

    // Ensure a maximum selection matches props
    var hasMaxSelected = maxSelected !== undefined && typeof maxSelected === 'number';
    isValid = isValid && (hasMaxSelected ? itemsChecked.size <= maxSelected : true);
    return isValid;
  }, [isRequired, itemsChecked.size, maxSelected, minSelected]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit || hasInteracted) {
      var isValid = validate();
      setCheckBoxFeedback(isValid ? undefined : errMsg);
      setCheckBoxError(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
    }
  }, [clickedSubmit, hasInteracted, validate, errMsg]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        var isValid = validate();
        setCheckBoxFeedback(isValid ? undefined : errMsg);
        setCheckBoxError(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
      }
    }
  }, [buttonControlPressed, currentStepReferences, inputRef, validate, errMsg]);
  (0, _react.useEffect)(() => {
    onChange([...itemsChecked], validate());
  }, [itemsChecked, onChange, validate]);
  var onFieldChange = (checked, option) => {
    if (checked) {
      setItemsChecked(prev => new Set(prev.add(option.value)));
    } else {
      setItemsChecked(prev => new Set([...prev].filter(storedValue => storedValue !== option.value)));
    }
    setHasInteracted(true);
  };
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    between: 2
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    style: {
      borderRadius: '0.1px',
      padding: '0px',
      outlineOffset: '8px',
      borderWidth: '0px',
      outline: checkBoxFeedback ? 'rgb(225, 35, 57) solid 1px' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("legend", {
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.InputLabel, {
    label: label,
    hint: hint,
    hintPosition: hintPosition
  }, (0, _utils.formatLabel)(label, isRequired, language))), hasOptions && /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, {
    outsideGutter: false
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, null, options.map((option, idx) => /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
    xs: 12,
    lg: twoColumnsOnDesktop ? 6 : 12,
    key: "CheckboxField_".concat(fieldName, "_").concat(option.label)
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    vertical: 1
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Checkbox, {
    "data-testid": "checkbox-".concat(idx),
    ref: idx === 0 ? inputRef : /*#__PURE__*/_react.default.createRef(),
    label: option.label,
    name: "CheckboxField_".concat(fieldName),
    value: option.value,
    checked: itemsChecked.has(option.value),
    onChange: checked => onFieldChange(checked, option),
    "data-di-mask": true,
    inactive: isReadOnly
  })))))), checkBoxFeedback && /*#__PURE__*/_react.default.createElement(_componentsWeb.Feedback, {
    title: checkBoxFeedback,
    variant: {
      icon: true
    },
    validation: checkBoxError
  }))));
};
CheckboxField.propTypes = {
  label: _propTypes.default.string.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  errorMessage: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.arrayOf(_propTypes.default.string),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired),
  twoColumnsOnDesktop: _propTypes.default.bool,
  minSelected: _propTypes.default.number,
  maxSelected: _propTypes.default.number,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  isReadOnly: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string
};
var _default = exports.default = CheckboxField;